import { Injectable } from '@angular/core'
import { PreloadingStrategy, Route } from '@angular/router'
import { catchError, mergeMap, Observable, of, timer } from 'rxjs'

import { NavigatorWithConnection } from '../types/browser.type'
import { HelperService } from './helper.service'

@Injectable({
	providedIn: 'root',
})
export class MobilePreloadingStrategy implements PreloadingStrategy {
	private readonly defaultPreloadDelayMs = 2500

	constructor(private readonly helperService: HelperService) {}

	preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
		if (route.data?.['preload'] !== true || !this.hasAuthenticatedSession() || this.shouldSkipPreloading()) {
			return of(null)
		}

		const delay = Number(route.data?.['preloadDelayMs'] ?? this.defaultPreloadDelayMs)
		return timer(delay).pipe(
			mergeMap(() => load()),
			catchError(() => of(null)),
		)
	}

	private hasAuthenticatedSession(): boolean {
		return Boolean(this.helperService.getUserData()?.access_token)
	}

	private shouldSkipPreloading(): boolean {
		if (typeof navigator === 'undefined') return false

		const connection = (navigator as NavigatorWithConnection).connection
		if (!connection) return false
		if (connection.saveData) return true

		const effectiveType = connection.effectiveType?.toLowerCase()
		if (effectiveType === 'slow-2g' || effectiveType === '2g') return true

		return typeof connection.downlink === 'number' && connection.downlink > 0 && connection.downlink < 2
	}
}
